import AdvancedSettingsModal from './AdvancedSettingsModal';

export default AdvancedSettingsModal;
